import { h, Component } from 'preact';
import TicketLogic from "../utils/ticket-logic";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Config from "../config.jsx";
import User from "../../../services/user"

import * as T from "../desktop-templates/prematch-right-col.jsx";
import AwrabetTicketLoadBet from '../../awrabet/desktop-components/ticket-load-bet.jsx';
import { useState } from 'preact/hooks';

export default class TicketLoadBet extends AwrabetTicketLoadBet {
	render() {
		return <div>
			<T.ColumnTitleRow>
				<T.ColumnTitleLabel><Trans>Ricarica Scommessa</Trans></T.ColumnTitleLabel>
			</T.ColumnTitleRow>
			<T.ColumnContent>
				<T.HelperText><Trans>Insert the code to load</Trans></T.HelperText>
				<T.ContentRowFlex>
					<T.InputContainer>
						<input type="text" onInput={e => this.setState({ ticketid: e.target.value, error: null })} class="text-inherit bg-transparent w-full  focus:outline-none focus:border-custom-orange focus:ring-1 focus:ring-custom-orange" />
					</T.InputContainer>
					<T.SubmitButton onClick={e => this.reloadReservedTicket()} />
				</T.ContentRowFlex>
				{this.state.error && <T.ErrorText>
					{this.state.error == 'login' && <Trans>Please login to load a bet</Trans>}
				</T.ErrorText>}
			</T.ColumnContent>
		</div>;
	}
}

export function TicketLoadCashier() {
	const [ticketCode, setTicketCode] = useState('');

	const handleSubmit = () => {
		TicketLogic.loadCashierTicket(ticketCode, (err, data) => {
			if (!!err) {
				alert(err);
				return;
			}
		})
	}

	if (!User.isAffiliate())
		return null;

	return <div>
		<T.ColumnTitleRow>
			<T.ColumnTitleLabel><Trans>Load Cashier Bet</Trans></T.ColumnTitleLabel>
		</T.ColumnTitleRow>
		<T.ColumnContent>
			<T.HelperText><Trans>Insert the cashier code</Trans></T.HelperText>
			<T.ContentRowFlex>
				<T.InputContainer>
					<input type="text" value={ticketCode} onInput={e => setTicketCode(e.target.value)} class="text-inherit bg-transparent w-full  focus:outline-none focus:border-custom-orange focus:ring-1 focus:ring-custom-orange" />
				</T.InputContainer>
				<T.SubmitButton onClick={e => handleSubmit()} />
			</T.ContentRowFlex>
		</T.ColumnContent>
	</div>
}